import React, { useState } from 'react'
import * as S from './styles'
import { Row, Col } from "react-bootstrap"
import Data from "./Data"
import { IoClose } from "react-icons/io5"
import img9 from "../../img/slider3.jpg"

export const Gallery = () => {

    const [isOpenModal, setIsOpenModal] = useState(false);
    const [img, setIMG] = useState('');

    const handleModal = (img) => {
        setIsOpenModal(!isOpenModal);

        setIMG(img)
    }

    return (
        <S.Container className="container">

            <h2>Galeria de Fotos</h2>

            <Row>

                {Data.map((item) => {
                    return (
                        <Col xs={12} md={6} lg={4} className="coluna-img" key={item.id} onClick={() => handleModal(item.img)}>
                            <img src={item.img} alt={item.alt} />
                        </Col>
                    )
                })}
            </Row>

            <S.Modal isOpenModal={isOpenModal} onClick={() => handleModal("")}>

                <IoClose className="icone-fechar" onClick={() => handleModal("")} />

                <div className="container">
                    <img src={img} alt="imagem galeria" />
                </div>

            </S.Modal>

        </S.Container>
    )
}
